import React, { useEffect, useState } from 'react';
import ClickUpReportModal from '../../../common/src/components/ClickUpReportModal';
import { format } from 'date-fns';
import { LoadingSpinner } from 'wg-fe-ui';
import { getI18nLanguageCode } from '../../../../i18n';
import useAuth from '../../../app/src/features/authentication/hooks/useAuth';

interface Props {
  vin?: string;
  setShowModal: (p: boolean) => void;
  rawResponse?: string;
}

interface Params {
  'Task name': string;
  Logrocket: string;
  Client: string;
  'Distribution Id': string;
  'Client Email': string;
  VIN: string;
  PostHog: string;
  Language: string;
  'Broker Plan': string;
  'Raw Response': string;
  'Request URL': string;
}

const ToolkitVinReportModalContainer: React.FC<
  React.PropsWithChildren<Props>
> = ({ vin, rawResponse, setShowModal }) => {
  const { user, distribution } = useAuth();
  const [parameters, setParameters] = useState<Params>();
  const date = format(new Date(), 'dd/MM/yyyy');
  const clickupIds = {
    nl: '22k7n-8114/EDQX966L9SY59OFD35',
    en: '22k7n-8128/A5AP9U2H5Y7DXX7R1Z',
    fr: '22k7n-8121/73IRZ284XPIRB7W23L',
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    const sessionRecordingUrl = sessionStorage.getItem('sessionRecordingUrl');
    const clickupUrlParams: Params = {
      Logrocket: sessionRecordingUrl?.split('?')[0] + `?t=${Date.now()}`,
      'Task name': `[${date}] Toolkit Feedback - Vin not found - ${vin}`,
      Client: distribution.name,
      'Client Email': user?.email || '',
      'Distribution Id': distribution.id,
      VIN: vin || '',
      PostHog: sessionStorage.getItem('posthog_session_url') || '',
      Language: getI18nLanguageCode(),
      'Broker Plan': user?.plan || '',
      'Raw Response': rawResponse || '',
      'Request URL': '/v1/api/vehicles/search',
    };
    setParameters(clickupUrlParams);
  };
  if (!parameters) {
    return <LoadingSpinner isAbsolute />;
  }
  return (
    <ClickUpReportModal
      params={parameters as Params}
      setShowModal={setShowModal}
      clickUpIds={clickupIds}
    />
  );
};

export default ToolkitVinReportModalContainer;
